"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _LazyImage = _interopRequireDefault(require("@insided/shared/uikit/LazyImage"));

var _classnames = _interopRequireDefault(require("classnames"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Card = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Card, _Component);

  var _super = _createSuper(Card);

  function Card() {
    (0, _classCallCheck2.default)(this, Card);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(Card, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          customClass = _this$props.customClass,
          style = _this$props.style,
          navigation = _this$props.navigation,
          title = _this$props.title,
          imageSrc = _this$props.imageSrc,
          metadata = _this$props.metadata,
          _this$props$headerTag = _this$props.headerTag,
          headerTag = _this$props$headerTag === void 0 ? 'h3' : _this$props$headerTag;
      var CardHeaderTag = headerTag;
      return (0, _preact.h)("article", {
        className: (0, _classnames.default)(customClass, 'card', 'card-widget-wrapper'),
        style: style
      }, navigation && (0, _preact.h)("a", {
        href: (0, _absoluteUrlRuntime.resolveUrl)(navigation.url),
        className: "card_url",
        target: navigation === null || navigation === void 0 ? void 0 : navigation.target
      }, imageSrc && (0, _preact.h)("figure", null, (0, _preact.h)(_LazyImage.default, {
        type: "background",
        src: (0, _absoluteUrlRuntime.resolveUrl)(imageSrc),
        className: "card_image"
      })), (0, _preact.h)("div", {
        className: "card_info"
      }, (0, _preact.h)("header", null, (0, _preact.h)(CardHeaderTag, {
        className: (0, _classnames.default)('h3', 'card_info__title', 'card-widget-title')
      }, title)), Boolean(metadata) && (0, _preact.h)("div", {
        className: "text--meta card-info__metadata"
      }, metadata))));
    }
  }]);
  return Card;
}(_preact.Component);

var _default = Card;
exports.default = _default;